import { render, staticRenderFns } from "./registro-rol.vue?vue&type=template&id=3852d001&"
import script from "./registro-rol.vue?vue&type=script&lang=js&"
export * from "./registro-rol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports